export const BASE_CLASSNAME = 'PONCHO-typography';
